<template>
  <div class="cp-seller-view">
    <XContainer class="cp-seller-view-x-container">
      <div class="has-text-weight-bold has-text-primary is-size-4 has-text-centered">
        {{ $t('sellers.title') }}
      </div>

      <br />

      <div class="cp-seller-view-item-container columns is-multiline is-mobile">
        <div
          class="column is-6-mobile is-4-tablet is-3-desktop"
          v-for="(seller, index) in sellers"
          :key="index"
        >
          <a class="cp-seller-view-item has-background-white" :href="seller.url">
            <img v-if="seller.image" :src="seller.image" />
            <p v-else class="has-text-link has-text-weight-bold has-text-centered">
              {{ seller.location_name_localized }}
            </p>
          </a>
        </div>
      </div>
    </XContainer>

    <b-carousel icon-pack="fas" icon-size="is-large" :arrow-hover="false">
      <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
        <img :src="carousel.url" />
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import { getDistributions } from '@/apis/distribution';
import XContainer from '@/components/XContainer.vue';

export default {
  name: 'SellerView',
  components: {
    XContainer,
  },
  data() {
    return {
      sellers: [],
      carousels: [
        {
          url:
            'https://ik.imagekit.io/gp6ncelz4g/prod-static/Export_Clover_Plus_Website_Design-64_tTQYpYAz-.png',
        },
        {
          url:
            'https://ik.imagekit.io/gp6ncelz4g/prod-static/Export_Clover_Plus_Website_Design-64_tTQYpYAz-.png',
        },
      ],
    };
  },
  watch: {
    $route: 'fetchData',
  },
  async mounted() {
    await this.fetchData();

    this.$store.dispatch('fetchCurrentProductName', this.$route.params.id);
  },
  methods: {
    async fetchData() {
      const loading = this.$buefy.loading.open();

      try {
        const { distributions } = await getDistributions(1, 9999, this.$route.params.id);
        this.sellers = distributions;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } finally {
        loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-seller-view {
  &-x-container {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  &-item-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-item {
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: 1px solid $primary;
    width: 100%;
    max-width: 200px;
    height: 200px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 555px) {
      height: 100px;
      max-width: 150px;
    }
  }

  /deep/ .carousel-item img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
